export class Model {
  constructor(data: any = null) {
    this.init();
    if (data !== null) {
      this.setAttributes(data);
    } else {
      this.initEmpty();
    }
  }

  // eslint-disable-next-line no-unused-vars
  public setAttributes(data: any): void {
    // To be overwritten
  }

  public initEmpty(): void {
    // To be overwritten
  }

  /**
   * @deprecated
   */
  public equals(object: any): boolean {
    return this === object;
  }

  public json(): any {
    return Object.assign({}, this);
  }

  protected init(): void {
    //
  }
}
